// eslint-disable-next-line no-unused-vars
import React from "react"
import { navigate } from "gatsby"
import { Eyebrow, Headline, CloseButton } from "@shared"

import { css } from "@jsUtils"
import { CONSTANTS, URLS } from "@data"

import Styles from "./successPage.module.scss"

const { COLORS } = CONSTANTS

const SuccessPage = props => {
  const { eyebrow, header, subHeader, component = null, bgColor = "dark" } = props

  const onClose = () => {
    navigate(URLS.EXO_WORKS)
  }

  return (
    <div className={Styles.body}>
      <div className={css(Styles.background, Styles[bgColor])} />
      <div className={Styles.header}>
        <CloseButton tabbing={0} onClose={onClose} ariaExpanded ariaLabel="Close" />
      </div>
      <div className={Styles.finished}>
        <div className={Styles.complete}>
          <Eyebrow className={css(Styles.eyebrow, Styles.eyedone)} color={COLORS.FLURO}>
            {eyebrow}
          </Eyebrow>
          <Headline size={1}>{header}</Headline>
          <p className={Styles.completeBody}>{subHeader}</p>
        </div>
      </div>
      {component}
    </div>
  )
}

export default SuccessPage
